export default `
Votre confiance est notre priorité et nous nous engageons à maintenir les normes les plus élevées en matière de sécurité et de protection de la vie privée. En utilisant Nurau, vous acceptez que :
- **Anonymisation** : Toutes les informations que vous fournissez seront anonymisées et utilisées uniquement pour améliorer nos services
- **Ce que nous recueillons** :
  - Nom, courriel, organisation, identifiants de connexion
  - Données sur l'appareil, l'utilisation et le soutien
- **Qui peut voir vos données** :
  - Vos conversations avec Nurau sont confidentielles.
  - Elles ne sont pas partagées avec votre gestionnaire ou votre organisation
- **Comment vos données sont utilisées** :
  - Pour exploiter et améliorer l'Application
  - Pour générer des conseils en milieu de travail assistés par IA et améliorer votre expérience sur l'Application. Notez que l'IA est passive et constitue uniquement un outil de soutien. Elle ne prend pas de décisions vous concernant et ne remplace pas le jugement humain
  - Pour respecter les obligations légales et assurer la sécurité
- **Où vos données peuvent aller** :
  - Si jamais des informations sont conservées ou consultées à l'extérieur du Québec, toutes les mesures de protection de la vie privée seront en place
- **Vos droits** :
  - Accéder à vos données, les corriger ou les supprimer
  - Révoquer votre consentement en tout temps
  - Contacter notre Responsable de la protection des renseignements personnels : legal@nurau.com
`;
